import { render, staticRenderFns } from "./SSTreatmentListView.vue?vue&type=template&id=5a015f18&scoped=true&"
import script from "./SSTreatmentListView.vue?vue&type=script&lang=js&"
export * from "./SSTreatmentListView.vue?vue&type=script&lang=js&"
import style0 from "./SSTreatmentListView.vue?vue&type=style&index=0&id=5a015f18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a015f18",
  null
  
)

export default component.exports